export default __webpack_public_path__ + "static/media/74.7ee7f135.jpeg";